<template>
  <div class="list">
    <joinHead title="观看党建政治学习视频"></joinHead>
    <videoList class="video-box"></videoList>
  </div>
</template>
<script>
import joinHead from "./module/head";
// 播放视频

import videoList from "./module/videoList";
export default {
  data() {
    return {
      shows:0
    };
  },
  components: {
    joinHead,
    videoList
  }
};
</script>
<style lang='scss' scoped>
.list {
  .video-box {
    background: #fff2df;
    position: absolute;
    width: 100%;
    top: 4.34rem;
    z-index: -10;
    padding-bottom: 0.2rem;
  }
  position: relative;
}
</style>